import { frontendURL } from '../../../helper/URLHelper';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import campaigns from './campaigns/campaigns.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import metaLeadgen from './metaLeadgen/metaLeadgen.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import surveys from './surveys/surveys.routes';
import tasks from './tasks/tasks.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import releaseNotes from './releaseNotes/releaseNotes.routes';
import whatsappTemplates from './whatsappTemplates/whatsappTemplates.routes';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';
import {
  TEAM_MANAGE_PERMISSIONS,
  INBOX_EDIT_PERMISSIONS,
  INBOX_MANAGE_PERMISSIONS,
  INBOX_AGENT_BOT_MANAGE_PERMISSIONS,
  LABEL_MANAGE_PERMISSIONS,
  LABEL_CREATE_PERMISSIONS,
  LABEL_EDIT_PERMISSIONS,
  LABEL_DELETE_PERMISSIONS,
  TASK_MANAGE_PERMISSIONS,
  TASK_CREATE_PERMISSIONS,
  TASK_EDIT_PERMISSIONS,
  TASK_DELETE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_MANAGE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_CREATE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_EDIT_PERMISSIONS,
  CUSTOM_ATTRIBUTE_DELETE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [
          'administrator',
          TEAM_MANAGE_PERMISSIONS,
          INBOX_EDIT_PERMISSIONS,
          INBOX_MANAGE_PERMISSIONS,
          INBOX_AGENT_BOT_MANAGE_PERMISSIONS,
          LABEL_MANAGE_PERMISSIONS,
          LABEL_CREATE_PERMISSIONS,
          LABEL_EDIT_PERMISSIONS,
          LABEL_DELETE_PERMISSIONS,
          TASK_MANAGE_PERMISSIONS,
          TASK_CREATE_PERMISSIONS,
          TASK_EDIT_PERMISSIONS,
          TASK_DELETE_PERMISSIONS,
          CUSTOM_ATTRIBUTE_MANAGE_PERMISSIONS,
          CUSTOM_ATTRIBUTE_CREATE_PERMISSIONS,
          CUSTOM_ATTRIBUTE_EDIT_PERMISSIONS,
          CUSTOM_ATTRIBUTE_DELETE_PERMISSIONS,
        ],
      },
      redirect: to => {
        const accountId = Number(to.params.accountId);
        const userPermissions = getUserPermissions(
          store.getters.getCurrentUser,
          accountId
        );

        const settingsRoutes = [
          {
            name: 'general_settings_index',
            permissions: ['administrator'],
          },
          {
            name: 'settings_teams_list',
            permissions: ['administrator', TEAM_MANAGE_PERMISSIONS],
          },
          {
            name: 'settings_inbox_list',
            permissions: [
              'administrator',
              INBOX_EDIT_PERMISSIONS,
              INBOX_MANAGE_PERMISSIONS,
              INBOX_AGENT_BOT_MANAGE_PERMISSIONS,
            ],
          },
          {
            name: 'settings_whatsapp_templates',
            permissions: ['administrator'],
          },
          {
            name: 'labels_list',
            permissions: [
              'administrator',
              LABEL_MANAGE_PERMISSIONS,
              LABEL_CREATE_PERMISSIONS,
              LABEL_EDIT_PERMISSIONS,
              LABEL_DELETE_PERMISSIONS,
            ],
          },
          {
            name: 'settings_tasks',
            permissions: [
              'administrator',
              TASK_MANAGE_PERMISSIONS,
              TASK_CREATE_PERMISSIONS,
              TASK_EDIT_PERMISSIONS,
              TASK_DELETE_PERMISSIONS,
            ],
          },
          {
            name: 'attributes_list',
            permissions: [
              'administrator',
              CUSTOM_ATTRIBUTE_MANAGE_PERMISSIONS,
              CUSTOM_ATTRIBUTE_CREATE_PERMISSIONS,
              CUSTOM_ATTRIBUTE_EDIT_PERMISSIONS,
              CUSTOM_ATTRIBUTE_DELETE_PERMISSIONS,
            ],
          },
          {
            name: 'custom_roles_list',
            permissions: ['administrator'],
          },
          {
            name: 'profile_settings_index',
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        ];

        const firstAccessibleRoute = settingsRoutes.find(route =>
          hasPermissions(route.permissions, userPermissions)
        );

        if (!firstAccessibleRoute) {
          return {
            name: 'home',
            params: { accountId: to.params.accountId },
          };
        }

        return {
          name: firstAccessibleRoute.name,
          params: { accountId: to.params.accountId },
        };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...campaigns.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...metaLeadgen.routes,
    ...reports.routes,
    ...sla.routes,
    ...surveys.routes,
    ...tasks.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...releaseNotes.routes,
    ...whatsappTemplates.routes,
  ],
};
